import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Body,
  BottomActionButton as BaseBottomActionButton,
  Header,
  PatientRequestCommentAccordion,
  NavigateBeforeButton,
  FullScreenLoader,
  ContentContainer,
  PatientSummary as BasePatientSummary,
} from "../../../components";
import type { Patient } from "../../../interfaces";
import { patientDefaultValues } from "../../../interfaces";

import { useRequestData } from "../../../hooks";
import { styled } from "@mui/material";

const BottomActionButton = styled(BaseBottomActionButton)(() => ({
  maxWidth: "none",
  width: "100%",
}));

const PatientSummary = styled(BasePatientSummary)(() => ({
  maxWidth: "none",
}));

export function RequestManagement() {
  const navigate = useNavigate();
  const { requestId = "" } = useParams();
  const { data: requestData, isPending } = useRequestData();

  const patient: Patient = useMemo(() => {
    return requestData?.patient ?? patientDefaultValues;
  }, [requestData]);

  if (isPending) return <RequestManagement.Skeleton />;

  return (
    <>
      <Header
        title={"Solicitud"}
        titleColor="black"
        left={<NavigateBeforeButton onClick={() => navigate(`/app/solicitudes`)} />}
      />
      <ContentContainer disableGutters>
        <Body>
          <PatientSummary
            patient={patient}
            prevRoute={`/app/solicitudes/${requestId}/gestionar`}
            requestId={requestId}
          />
          <PatientRequestCommentAccordion
            request={
              requestData?.request ? { ...requestData.request, patient } : undefined
            }
            canReject={true}
            isExpanded={true}
          />

          <BottomActionButton onClick={() => navigate("./seleccionar-documento")}>
            Crear documento médico
          </BottomActionButton>
        </Body>
      </ContentContainer>
    </>
  );
}

RequestManagement.Skeleton = function RequestManagementSkeleton() {
  const navigate = useNavigate();

  return (
    <>
      <Header
        title={"Solicitud"}
        titleColor="black"
        left={<NavigateBeforeButton onClick={() => navigate(`/app/solicitudes`)} />}
      />
      <ContentContainer flex={1} disableGutters>
        <Body justifyContent="center">
          <FullScreenLoader title="Cargando información..." />
        </Body>
      </ContentContainer>
    </>
  );
};
